// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_1rdod","share-button":"_4FHj-","email":"_2LrRr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareModal/EmailShareButton.scss
// module id = ./src/components/ShareModal/EmailShareButton.scss
// module chunks = 4